import FormInputTypes from '../components/atoms/formEnums/formInputTypes';

export default {
  attributeName: 'sportRoomTeam',
  getURL: 'appId/appTeam',
  sessionParams: ['appId'],
  isDragable: false,
  canOpen: false,
  canEdit: false,
  canCreate: false,
  canRemove: false,
  isSelectable: true,
  isMultiSelectable: true,
  emptyMessage: "You don't have Teams, click on the \"+\" icon to create one.",
  fields: [
    {
      attributeName: 'short',
      label: 'Abbr',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      default: '',
      canOrder: true,
      canFilter:true,
      canEdit: false,
      canCreate: false,
      helpText: 'Short name of the team.',
      width:'5rem'
    },
    {
      attributeName: 'name',
      label: 'Name',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      default: '',
      canOrder: true,
      canFilter:true,
      canEdit: false,
      canCreate: false,
      helpText: 'Name of the team.',
    },
    {
      attributeName: 'info',
      label: 'Info',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      default: '',
      canOrder: true,
      canFilter:true,
      canEdit: false,
      canCreate: false,
      helpText: 'Extra info field .',
    },
    {
      attributeName: 'logo',
      label: 'Logo',
      type: FormInputTypes.DOWNLOADABLE,
      default: '',
      canOrder: false,
      canFilter:false,
      canEdit: false,
      canCreate: false,
      helpText: 'Extra info field .',
    },
  ],
};
